export default "__VITE_ASSET__DXQP0G54__"